import styled, { css } from 'styled-components';

export const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-left: var(--sidebarWidth);
  padding-top: 3rem;
  min-height: 100vh; /* Full viewport height */
`;
export const SubscriptionStatus = styled.h5`
  ${props =>
    props.isactive
      ? css`
          color: green; /* Set color to green if active */
        `
      : css`
          color: red; /* Set color to red if inactive */
        `}
`;

export const CustomLink = styled.a`
  position: relative;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
  text-decoration: underline; /* Add underline on hover */
}
`;